import { render, staticRenderFns } from "./ManageSettingsView.vue?vue&type=template&id=7d132dee"
import script from "./ManageSettingsView.vue?vue&type=script&lang=ts"
export * from "./ManageSettingsView.vue?vue&type=script&lang=ts"
import style0 from "./ManageSettingsView.vue?vue&type=style&index=0&id=7d132dee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports